// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"23179663","280":"93dead3d","494":"d53de1ab"}[chunkId] + ".chunk.js";
};